import useSWR from 'swr'

import { menuRecipeFetcherV3 } from '@library/menu-service'
import { MenuRecipe } from '@library/menu-service/queries/menuApiMenuRecipe/types'

export const useFetchRecipe = (
  menuId: string,
  // there is no recipe when the details modal is closed
  recipeUuid: string | null,
  numPortions: number,
  deliveryDate: string,
  shouldFetchOptions = true,
  collectionId?: string,
): {
  error: boolean
  loading: boolean
  recipe: MenuRecipe | null
  reload: () => void
} => {
  const { data, mutate, isValidating, error } = useSWR(
    () =>
      recipeUuid && shouldFetchOptions
        ? {
            menuId,
            recipeId: recipeUuid,
            numPortions,
            deliveryDate,
            collectionId,
          }
        : null,
    menuRecipeFetcherV3,
  )

  const reload = () => {
    mutate()
  }

  return {
    error: !!error,
    loading: !data && isValidating,
    recipe: data || null,
    reload,
  }
}
